var colors = require('./colors');

var fonts = require('./fonts');

exports.colors = colors;
exports.fonts = fonts;